import React, { useState } from "react";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { fr } from "date-fns/locale";
import { Helmet } from 'react-helmet-async';
import { blockInvalidChar } from "../../components/blockInvalidChar";
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';
import { AjouteReservationDirect } from '../../Api/RestaurantApi/ReservationDirectApi';
import './css/prendreResaResto.css';

const PrendreReservation = () => {
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const createDateFromTextValue = (value) => {
    const splitParts = value.split(":");
    return new Date(2022, 1, 1, splitParts[0], splitParts[1]);
  };
  const [creneau, setCreneau] = useState(createDateFromTextValue("00:00"));
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [telephone, setTelephone] = useState('');
  const [prise, setPrise] = useState('');
  const [email, setEmail] = useState('');
  const [canal, setCanal] = useState('');
  const [nbrPersonne, setNbrPersonne] = useState('');
  const [demande, setDemande] = useState('');
  const [errorCreneau, setErrorCreneau] = useState('');

  let location = useLocation();

  const restaurant = useSelector((state) => state.restaurant);

  const dateFormat = (date) => {
    if (date < 10) {
      return '0' + date;
    } else {
      return date;
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!localStorage.getItem('tokenSociete')) {
      if (creneau.getHours() === 0) {
        setErrorCreneau('Donner obligatoire');
        const timer = setTimeout(() => setErrorCreneau(''), 3000);
        return () => clearTimeout(timer);
      } else {
        setLoading(true);
        var opt_month = { month: 'short' };

        const data = {
          idRestaurant: restaurant.id, anne: date.getFullYear(), mois: date.toLocaleDateString('en-US', opt_month), jour: dateFormat(date.getDate()),
          nom: nom, prenom: prenom, telephone: telephone, email: email, nombrePersonne: nbrPersonne, demandeSpecifique: demande, creneau: dateFormat(creneau.getHours()) + ":" + dateFormat(creneau.getMinutes()), prise: prise, canal: canal
        };
        AjouteReservationDirect(data).then(function (response) {
          if (response.data.title === "success") {
            toast.success(response.data?.message);
          }
        }).catch(function (error) {
          console.log(error.response);
          toast.warning(error.response.data?.message);
        }).finally(function () {
          setDate(new Date());
          setCreneau(createDateFromTextValue("00:00"));
          setNom('');
          setPrenom('');
          setTelephone('');
          setEmail('');
          setNbrPersonne('');
          setDemande('');
          setPrise('');
          setCanal('');
          setLoading(false);
        });
      }
    } else {
      toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
  }

  const handleCancel = () => {
    setDate(new Date());
    setCreneau(createDateFromTextValue("00:00"));
    setNom('');
    setPrenom('');
    setTelephone('');
    setEmail('');
    setNbrPersonne('');
    setDemande('');
    setPrise('');
    setCanal('');
  }


  return (
    <div>
      <Helmet>
        <title>Prendre réservation</title>
        <meta name='description' content='Prendre réservation.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className="prendre_reservation">
        <div className="container">
          <div className="bloc_prendre_reservation">
            <div className='prendre_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-check'></i> <h1>Prendre une réservation</h1>
              </div>
              <div className='prendre_renseignement'>
                <p>Vous pouvez prendre vos réservation direct ici, et ainsi vous auriez l’ensemble de votre agenda en ligne
                  Aucun champ n’est obligatoire : fonction de votre organisation.
                  Cependant, il est préférable que vous demandiez le maximum d’information pour un meilleur suivi, notamment si vous souhaitez contacter vos clients en direct, pour confirmation de la réservation et/ou pour l’envoi de vos campagnes d’e-mailing par la suite.
                </p>
              </div>
            </div>
            <div className="prendre_content">
              <form onSubmit={handleSubmit}>
                <div className="form_prendre">
                  <div className='row'>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                      <div>
                        <div className="element ">
                          <label htmlFor="date" className="col-form-label">Nom: </label>
                          <div className="input">
                            <input type="text" value={nom} onChange={(e) => setNom(e.target.value)} required className="form-control" placeholder="Nom ..." />
                          </div>
                        </div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Prénom: </label>
                          <div className="input">
                            <input type="text" value={prenom} onChange={(e) => setPrenom(e.target.value)} required className="form-control" placeholder="Prénom ..." />
                          </div>
                        </div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Numéro téléphone: </label>
                          <div className="input ">
                            <input type="text" value={telephone} onChange={(e) => setTelephone(e.target.value)} required className="form-control" placeholder="Numéro téléphone ..." />
                          </div>
                        </div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Réservation prise par: </label>
                          <div className="input ">
                            <input type="text" value={prise} onChange={(e) => setPrise(e.target.value)} required className="form-control" placeholder="Prise par ..." />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                      <div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Adresse email: </label>
                          <div className="input ">
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder="Adresse email ..." />
                          </div>
                        </div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Canal en direct par: </label>
                          <div className="input ">
                            <input type="text" value={canal} onChange={(e) => setCanal(e.target.value)} required className="form-control" placeholder="Ex: téléphone,email,sur place ..." />
                          </div>
                        </div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Date: </label>
                          <div className="input ">
                            <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                value={date}
                                placeholder="10/10/2018"
                                required
                                onChange={value => setDate(value)}
                                minDate={new Date()}
                                format="MM/dd/yyyy"
                              />

                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center">
                      <div>
                        <div className="element ">
                          <label htmlFor="date" className="col-form-label">Créneau: </label>
                          <div className="input ">
                            <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                              <div className="d-flex flex-column">
                                <KeyboardTimePicker
                                  label="Créneau"
                                  placeholder="00:00"
                                  ampm={false}
                                  name="creneau"
                                  required
                                  minutesStep={5}
                                  value={creneau}
                                  onChange={date => setCreneau(createDateFromTextValue(date.getHours() + ":" + date.getMinutes()))}
                                />
                              </div>
                            </MuiPickersUtilsProvider>
                            {errorCreneau !== "" ? <span className='errorValue  mt-1'>{errorCreneau}</span> : ""}
                          </div>
                        </div>
                        <div className="element ">
                          <label htmlFor="date" className="col-form-label">Nombre de personnes: </label>
                          <div className="input ">
                            <input type="number" value={nbrPersonne} onChange={(e) => setNbrPersonne(e.target.value)} required onKeyDown={blockInvalidChar} className="form-control number" placeholder="0" />
                          </div>
                        </div>
                        <div className="element">
                          <label htmlFor="date" className="col-form-label">Demande spécifique: </label>
                          <div className="input ">
                            <textarea className="form-control" value={demande} onChange={(e) => setDemande(e.target.value)} id="exampleFormControlTextarea1" placeholder="Demande spécifique ..." rows="1" />
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <div className="action mt-4">
                    <div className="d-flex justify-content-center">
                      <button type="button" className="btn annuler" onClick={handleCancel}>Annuler</button>

                      {loading ? <Button className='btn btn_ajouteReservationDirect' disabled>
                        <Spinner

                          animation="border"
                          size="sm"
                          variant="info"
                        />
                        Loading...
                      </Button> : <button type="submit" className="btn valider">Valider</button>}
                    </div>
                  </div>
                  <p className='version'>Version 1</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default PrendreReservation